import React, { Component } from 'react';
import Question from './question';
import './css/question.css';

class QuestionList extends Component {

  constructor() {
    super();
    this.state = { currentTime: 0, listToShow: [], fullQuestionList: []};
    this.setListToShow = this.setListToShow.bind(this);
    this.clearCurrentTimeout = this.clearCurrentTimeout.bind(this);
    this.timer = 0;
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.questionList !== this.state.fullQuestionList) {
      this.clearCurrentTimeout()
      this.setListToShow(nextProps.questionList);
    }
  }

  setListToShow(fullList) {
    var newListToShow = [];
    var newTime = 0;
    for (var i = 0; i < fullList.length; i++) {
      if (fullList[i]['whenToShowMs'] <= this.state.currentTime) {
        newListToShow.push(fullList[i]);
      } else {
        newTime = parseInt(fullList[i]['whenToShowMs'], 10);
        break;
      }
    }

    var timeDiff = newTime - this.state.currentTime
    this.setState({ currentTime: newTime, listToShow: newListToShow, fullQuestionList: fullList})
    if (timeDiff > 0) {
      this.timer = setTimeout(this.setListToShow, timeDiff, fullList);
    }
  }

  componentWillUnmount() {
    this.clearCurrentTimeout()
  }

  clearCurrentTimeout() {
    if (this.timer !== 0) {
      clearTimeout(this.timer)
    }
  }

  render() {
  	const questionDtoList = this.state.listToShow;

    const questionItems = questionDtoList.map((questionDto, i) =>
      <Question key = {i} questionDto = {questionDto}></Question>
    );
    return (
      <ul className = "QuestionList">{questionItems}</ul>
    );
    
  }
}

export default QuestionList;



// WEBPACK FOOTER //
// ./src/components/questionList.js